<template>
  <div class="cotton-inspection2">
    <MCard class="content" :title="title" title-align="center" :icon="icon" ref="content">
      <div class="device-list" :style="{ '--rows': rows }">
        <template v-for="item in data">
          <DeviceCard :key="item.sn" :data="item"></DeviceCard>
        </template>
      </div>
    </MCard>
  </div>
</template>

<script>
import MCard from '@/components/mCard/index.vue';
import DeviceCard from './components/deviceCard.vue';

import { cottonResultStateUtils } from '../../utils/status';
import { openInspectionMenu } from '../../utils/contextMenu';
import { mapState } from 'vuex';
import { isEmpty } from '@/utils/is';
import { clamp } from '@/utils/math';

export default {
  mixins: [cottonResultStateUtils.mixins],
  components: { MCard, DeviceCard },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isEmpty,
      icon: {
        type: 'image',
        config: {
          src: '/static/image/cotton/inspection.png'
        }
      }
    };
  },
  computed: {
    ...mapState('socket', ['deviceSNMap', 'deviceIdMap']),
    title() {
      const id = this.$route.params.id;

      return `${this.$t('巡检')}(${this.deviceIdMap[id]?.name})`;
    },
    rows() {
      const method = window.innerHeight > 1080 ? 'ceil' : 'floor';

      const len = Math[method](this.data.length / 3);

      return clamp(len, 2, 3);
    }
  },
  methods: {
    openContextmenu(row, _column, event) {
      event.preventDefault();

      openInspectionMenu.call(this, event, {
        sn: row.sn,
        deviceType: 'cd602'
      });
    }
  }
};
</script>

<style lang="scss">
.cotton-inspection2 {
  width: 100%;
  height: var(--top-height);

  position: absolute;
  left: 0;
  top: 0;

  .device-list {
    --rows: 2;

    height: 100%;
    box-sizing: border-box;
    overflow: auto;
    width: 100%;
    padding: 20px;

    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    @include scrollar-style-thin;

    & > div {
      width: calc(33.333% - 40px / 3);
      height: calc(100% / var(--rows) - 20px * (var(--rows) - 1) / var(--rows));

      min-height: max-content;
    }
  }
}
</style>
